import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { createEnum } from 'utils/enum';
import {
    propTypes as toggleablePropTypes,
    defaultProps as toggleableDefaultProps,
} from 'containers/Toggleable';
import DropdownActionButton from './DropdownActionButton';
import DropdownFooter from './DropdownFooter';

export const ALIGNMENT = createEnum('left', 'right', 'center', 'toggle');

export const itemPropTypes = {
    value: PropTypes.string.isRequired,
    label: PropTypes.node,
    border: PropTypes.bool,
    disabled: PropTypes.bool,
};

export const itemDefaultProps = {
    label: '',
    disabled: false,
};

export const propTypes = {
    ...toggleablePropTypes,
    id: PropTypes.string,
    tabIndex: PropTypes.number,
    maxHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    minWidth: PropTypes.number,
    role: PropTypes.string,
    disabled: PropTypes.bool,
    scrollable: PropTypes.bool,
    arrow: PropTypes.bool,
    padded: PropTypes.bool,
    alignment: PropTypes.oneOf(ALIGNMENT.values()),
    positionHorizontally: PropTypes.bool,
    actionButton: PropTypes.elementOfType([DropdownActionButton]),
    usePortal: PropTypes.bool,
    useFocusTrap: PropTypes.bool,
    useToggleContainer: PropTypes.bool,
    renderToggle: PropTypes.func,
    toggle: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
    openOnFocus: PropTypes.bool,
    openOnKeyDown: PropTypes.bool,
    toggleRef: PropTypes.ref(),
    popoverRef: PropTypes.ref(),
    toggleOnClick: PropTypes.bool,
    toggleWithSpace: PropTypes.bool,
    toggleWithEnter: PropTypes.bool,
    closeWithTab: PropTypes.bool,
    closeOnClickOutside: PropTypes.bool,
    closeOnScroll: PropTypes.bool,
    quick: PropTypes.bool,
    onClickOutside: PropTypes.func,
    onKeyDown: PropTypes.func,
    onClick: PropTypes.func,
    onFocus: PropTypes.func,
    toggleClassName: PropTypes.string,
    dropdownClassName: PropTypes.string,
    containerClassName: PropTypes.string,
    contentClassName: PropTypes.string,
    className: PropTypes.string,
    footer: PropTypes.oneOfType([PropTypes.elementOfType([DropdownFooter]), PropTypes.node]),
    children: PropTypes.node,
};

export const defaultProps = {
    ...toggleableDefaultProps,
    id: '',
    tabIndex: 0,
    maxHeight: 0,
    minWidth: 0,
    role: 'region',
    disabled: false,
    scrollable: true,
    arrow: true,
    padded: true,
    alignment: ALIGNMENT.RIGHT,
    positionHorizontally: false,
    actionButton: null,
    usePortal: true,
    useFocusTrap: false,
    useToggleContainer: false,
    openOnFocus: false,
    openOnKeyDown: false,
    toggleRef: noop,
    popoverRef: noop,
    toggleOnClick: true,
    toggleWithSpace: true,
    toggleWithEnter: true,
    closeWithTab: false,
    closeOnClickOutside: true,
    closeOnScroll: true,
    onClickOutside: noop,
    quick: false,
    onKeyDown: noop,
    onClick: noop,
    onFocus: noop,
    toggleClassName: null,
    dropdownClassName: null,
    containerClassName: null,
    contentClassName: null,
    className: null,
    footer: null,
};
